
export enum NotificationTypes {
    LEARNING = "LEARNING",
    WANTS_TO_JOIN = "WANTS_TO_JOIN",
    LOGGED_OUT = "LOGGED_OUT",
    PLAYER_LEFT = "PLAYER_LEFT",
    NETWORK_ISSUE = "NETWORK_ISSUE",
    QUESTION = "QUESTION"
}